/* tslint:disable */
/* eslint-disable */
/**
 * Keyops CEP
 * Customer Engagement Platform API documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 * 
 *
 * @export
 * @interface User
 */
export interface User {

    /**
     * The ID of the database object
     *
     * @type {string}
     * @memberof User
     * @example 8762c685-9c17-496f-a145-48855464b885
     */
    id: string;

    /**
     * The date the object was created
     *
     * @type {string}
     * @memberof User
     * @example 2023-01-01T00:00:00.000Z
     */
    createdAt: string;

    /**
     * The date the object was last updated
     *
     * @type {string}
     * @memberof User
     * @example 2023-01-01T00:00:00.000Z
     */
    updatedAt: string;

    /**
     * The email of the AuthenticatedUser
     *
     * @type {string}
     * @memberof User
     * @example test@test.com
     */
    email: string;

    /**
     * The display name of the AuthenticatedUser
     *
     * @type {string}
     * @memberof User
     * @example Test User
     */
    displayName: string;

    /**
     * The ID of the User's tenant
     *
     * @type {string}
     * @memberof User
     * @example 8762c685-9c17-496f-a145-48855464b885
     */
    tenantId: string;

    /**
     * Whether or not the user has signed up yet
     *
     * @type {boolean}
     * @memberof User
     * @example true
     */
    registered: boolean;

    /**
     * The role of the user, should always be \"user\"
     *
     * @type {string}
     * @memberof User
     * @example user
     */
    role: string;

    /**
     * The active status of the User
     *
     * @type {boolean}
     * @memberof User
     * @example true
     */
    isActive: boolean;

    /**
     * Entitlements for the user
     *
     * @type {Array<string>}
     * @memberof User
     * @example ["AccessMarketResearch"]
     */
    entitlements: Array<UserEntitlementsEnum>;
}

/**
 * @export
 * @enum {string}
 */
export enum UserEntitlementsEnum {
    AccessMarketResearch = 'AccessMarketResearch',
    AccessOwnEvaluationEvents = 'AccessOwnEvaluationEvents',
    AccessAllEvaluationEvents = 'AccessAllEvaluationEvents'
}

